/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-touchevents-setclasses !*/
!function(e,n,t){function o(e,n){return typeof e===n}function s(){var e,n,t,s,a,i,r;for(var l in c)if(c.hasOwnProperty(l)){if(e=[],n=c[l],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(t=0;t<n.options.aliases.length;t++)e.push(n.options.aliases[t].toLowerCase());for(s=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],r=i.split("."),1===r.length?Modernizr[r[0]]=s:(!Modernizr[r[0]]||Modernizr[r[0]]instanceof Boolean||(Modernizr[r[0]]=new Boolean(Modernizr[r[0]])),Modernizr[r[0]][r[1]]=s),f.push((s?"":"no-")+r.join("-"))}}function a(e){var n=u.className,t=Modernizr._config.classPrefix||"";if(p&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+t+"no-js(\\s|$)");n=n.replace(o,"$1"+t+"js$2")}Modernizr._config.enableClasses&&(n+=" "+t+e.join(" "+t),p?u.className.baseVal=n:u.className=n)}function i(){return"function"!=typeof n.createElement?n.createElement(arguments[0]):p?n.createElementNS.call(n,"http://www.w3.org/2000/svg",arguments[0]):n.createElement.apply(n,arguments)}function r(){var e=n.body;return e||(e=i(p?"svg":"body"),e.fake=!0),e}function l(e,t,o,s){var a,l,f,c,d="modernizr",p=i("div"),h=r();if(parseInt(o,10))for(;o--;)f=i("div"),f.id=s?s[o]:d+(o+1),p.appendChild(f);return a=i("style"),a.type="text/css",a.id="s"+d,(h.fake?h:p).appendChild(a),h.appendChild(p),a.styleSheet?a.styleSheet.cssText=e:a.appendChild(n.createTextNode(e)),p.id=d,h.fake&&(h.style.background="",h.style.overflow="hidden",c=u.style.overflow,u.style.overflow="hidden",u.appendChild(h)),l=t(p,e),h.fake?(h.parentNode.removeChild(h),u.style.overflow=c,u.offsetHeight):p.parentNode.removeChild(p),!!l}var f=[],c=[],d={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var t=this;setTimeout(function(){n(t[e])},0)},addTest:function(e,n,t){c.push({name:e,fn:n,options:t})},addAsyncTest:function(e){c.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=d,Modernizr=new Modernizr;var u=n.documentElement,p="svg"===u.nodeName.toLowerCase(),h=d._config.usePrefixes?" -webkit- -moz- -o- -ms- ".split(" "):["",""];d._prefixes=h;var m=d.testStyles=l;Modernizr.addTest("touchevents",function(){var t;if("ontouchstart"in e||e.DocumentTouch&&n instanceof DocumentTouch)t=!0;else{var o=["@media (",h.join("touch-enabled),("),"heartz",")","{#modernizr{top:9px;position:absolute}}"].join("");m(o,function(e){t=9===e.offsetTop})}return t}),s(),a(f),delete d.addTest,delete d.addAsyncTest;for(var v=0;v<Modernizr._q.length;v++)Modernizr._q[v]();e.Modernizr=Modernizr}(window,document);


$(function () {

//animation
    var firstLoad = new TimelineMax({onComplete: function () {
            $('[data-slide="1"] [data-stagger]').removeAttr('style');
        }});

    firstLoad
        .fromTo($('[data-slide="1"]'), 0.5,{opacity: 0},{opacity: 1}, '+=0.05')
        .fromTo($('header'), 0.5,{opacity: 0},{opacity: 1}, '-=0.5')
        .fromTo($('.pagination-fp'), 0.5,{opacity: 0},{opacity: 1}, '-=0.35')
        .fromTo($('.bg-coins'), 0.5,{opacity: 0},{opacity: 1}, '-=0.2')
        .staggerFromTo($('[data-slide="1"] [data-stagger]'),0.2,{y:40,opacity:0},{y:0,opacity:1},0.1);

    //footer plane
    var plane = $('#footer-plane');
    var tlPlane = new TimelineMax({repeat: -1});
    tlPlane
        .set(plane, {y:80,opacity:0,rotation:0})
        .to(plane, 2,{y:0, opacity: 1, ease: Power0.easeNone,}, "+=1")
        .to(plane, 2,{y:-80, opacity: 0, ease: Power0.easeNone,})
        .set(plane, {y:-80,opacity:0,rotation:180})
        .to(plane, 2,{y:0, opacity: 1, ease: Power0.easeNone,}, "+=1")
        .to(plane, 2,{y:80, opacity: 0, ease: Power0.easeNone,})
    ;

    //footer circle
    setTimeout(function() {
        if ( $('.bg-circle').length && $(window).outerWidth() > 1199 ) {
            var circleSVG = $('.bg-circle')[0].contentDocument;
            var ovalL1 = $(circleSVG).find('#oval-l-1')[0];
            var ovalL2 = $(circleSVG).find('#oval-l-2')[0];
            var ovalL3 = $(circleSVG).find('#oval-l-3')[0];
            var ovalR1 = $(circleSVG).find('#oval-r-1')[0];
            var ovalR2 = $(circleSVG).find('#oval-r-2')[0];
            var ovalR3 = $(circleSVG).find('#oval-r-3')[0];

            var tlOval = new TimelineMax({repeat: -1,yoyo: true});
            tlOval
                .set([ovalL1,ovalL2,ovalL3], {opacity:0})
                .set([ovalR1,ovalR2,ovalR3], {opacity:1})
                .to(ovalL1, 2,{opacity: 1, ease: Power0.easeNone,})
                .addLabel("step2", "-=0.66")
                .to(ovalL2, 2,{opacity: 1, ease: Power0.easeNone,}, "step2")
                .addLabel("step3", "-=1.33")
                .to(ovalL3, 2,{opacity: 1, ease: Power0.easeNone,}, "step3")
                .to(ovalR3, 2,{opacity: 0, ease: Power0.easeNone,}, 0)
                .to(ovalR2, 2,{opacity: 0, ease: Power0.easeNone,}, "step2")
                .to(ovalR1, 2,{opacity: 0, ease: Power0.easeNone,}, "step3")
            ;

        }
    }, 5000);

    //hover perspective
    var hoverPerspective = function() {

        var el = $("[data-hover-perspective]");
        TweenMax.set(el, {
            rotationY: 0,
            rotationX: 0,
            rotationZ: 0,
            transformPerspective: 1e3
        });

        el.mouseover(function() {
            el.mousemove(function(e) {
                var relX = e.pageX - $(this).offset().left,
                    relY = e.pageY - $(this).offset().top,
                    rateX = relX / $(this).width(),
                    rateY = relY / $(this).height(),
                    rotX = -6 + 12 * rateX,
                    rotY = 6 - 12 * rateY;
                TweenMax.to($(this), .5, {
                    rotationY: rotX,
                    rotationX: rotY,
                    rotationZ: 0,
                    transformPerspective: 1e3,
                    ease: Quad.easeOut
                })
            })
        }).mouseout(function() {
            $(this).unbind("mousemove");
            TweenMax.to($(this), .5, {
                rotationY: 0,
                rotationX: 0,
                rotationZ: 0,
                transformPerspective: 1e3,
                ease: Quad.easeOut
            });
        });
    };

//detect Mac
//     var isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
//support touchevent
//     if (!Modernizr.touchevents && !isMac) {
    if (!Modernizr.touchevents) {
        // not-supported
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf('safari') != -1) {
            if (ua.indexOf('chrome') > -1) {
                hoverPerspective();
            } else {

            }
        }else{
            hoverPerspective();
        }
    } else {
        // supported
    }

    // $('[data-gotoslide="2"]').trigger('click'); // quick jump to slide

    // #0be0c6,#034dec
    // var btnHover = $("[data-btnhover]");
    //
    // var tla = new TimelineMax({
    //     paused: true
    // });
    // tla
    //     .to({left: "#0be0c6", right: "#034dec"}, 1.5, {colorProps:{left:"#034dec", right: "#0be0c6"},onUpdate: colorize, onUpdateParams: $(".hover[data-btnhover]")})
    // ;
    //
    // btnHover.mouseover(function() {
    //     $(this).addClass("hover");
    //     tla.play();
    //     console.log("hover");
    // });
    // btnHover.mouseout(function() {
    //     $(this).removeClass("hover");
    //     tla.reverse();
    // });
    // function colorize(element) {
    //     TweenLite.set(element, {
    //         // background: "linear-gradient(90deg," + colors.left + ", " + colors.right + ")"
    //         background: "linear-gradient(90deg, #0be0c6, #034dec)"
    //     });
    // }
});

// var radioValue = number_format($(this).val(), 0, ',', ' ');
function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return '' + (Math.round(n * k) / k)
                .toFixed(prec);
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
        .split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '')
        .length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1)
            .join('0');
    }
    return s.join(dec);
}